var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { Endpoint } from 'app/stores/common';
import { EditorActions } from 'app/stores/editor/actions';
import { Prompt } from 'app/stores/editor/prompt';
import { ProjectActions } from 'app/stores/project/actions';
import { getURLRegEx } from 'app/utils/varia';
export const downloadImage = createAsyncThunk('image/download', (url, { dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    if (!url || !url.match(getURLRegEx())) {
        throw new Error('Invalid image url');
    }
    dispatch(EditorActions.showBusy({ message: 'Downloading image data' }));
    const endpoint = Endpoint.shared.downloadProxy();
    const proxiedUrl = `${endpoint}?url=${encodeURIComponent(url)}`;
    let response;
    try {
        response = yield axios.get(proxiedUrl, {
            responseType: 'blob',
        });
    }
    catch (error) {
        if (error instanceof Error) {
            if ((error === null || error === void 0 ? void 0 : error.isAxiosError) === true) {
                response = error.response;
            }
        }
    }
    dispatch(EditorActions.hideBusy());
    // if there is a response -> deal with it
    if (response) {
        switch (response.status) {
            case 200:
                {
                    const { data } = response;
                    yield dispatch(ProjectActions.createFromImageData({
                        data,
                        source: 'download',
                    }));
                }
                return;
            case 401: //  unauthorized
                yield dispatch(Prompt.show({
                    title: 'Image download error',
                    variant: 'error',
                    content: 'Unauthenticated access',
                }));
                return;
            case 404: // not found
                yield dispatch(Prompt.show({
                    title: 'Image download error',
                    variant: 'error',
                    content: 'Resource not found',
                }));
                return;
            case 415: // Unsupported Media Type
                yield dispatch(Prompt.show({
                    title: 'Image download error',
                    variant: 'error',
                    content: 'Unsupported media type found',
                }));
                return;
            default:
                break;
        }
    }
    yield dispatch(Prompt.show({
        title: 'Image download error',
        variant: 'error',
        content: 'Failed to download image',
    }));
}));
